export default __webpack_public_path__ + "images/aa28f58418fc00f74b7eefd1618e6310.svg";